/** Mermaid — renders a complete mermaid code block as an SVG diagram.
 *  AssistantMessage only mounts this once the ```mermaid fence is closed. */

import React, { useEffect, useState } from "react";
import mermaid from "mermaid";

mermaid.initialize({
  startOnLoad: false,
  securityLevel: "strict",
  theme: "default",
});

let mermaidIdCounter = 0;

const Mermaid = ({ chart }) => {
  const [svg, setSvg] = useState("");
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const id = `mermaid-${mermaidIdCounter++}`;
    mermaid
      .render(id, chart)
      .then(({ svg: rendered }) => {
        if (cancelled) return;
        setSvg(rendered);
        setFailed(false);
      })
      .catch(() => {
        if (!cancelled) setFailed(true);
      })
      .finally(() => {
        // Drop mermaid's temp <body> node (holds its bomb graphic on error).
        document.getElementById(`d${id}`)?.remove();
        const orphan = document.getElementById(id);
        if (orphan && orphan.parentElement === document.body) orphan.remove();
      });

    return () => {
      cancelled = true;
    };
  }, [chart]);

  // Show the raw text if a diagram genuinely fails to render.
  if (failed && !svg) {
    return (
      <pre className="bg-gray-100 border border-gray-200 p-3 rounded-md my-2 text-sm overflow-x-auto">
        {chart}
      </pre>
    );
  }

  return (
    <div
      className="my-3 flex justify-center overflow-x-auto [&_svg]:max-w-full [&_svg]:h-auto"
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
};

export { Mermaid };
